//M10-9403-Division
import React, { useState, useRef, useEffect } from 'react';
import downArrow from "src/assets/down-arrow.svg";


interface MultiSelectProps {
  options: { value: string; label: string }[];
  value: string[];
  onChange: (selectedOptions: string[]) => void;
  isDisabled?: boolean;
  placeholder?: string;
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  options,
  value,
  onChange,
  isDisabled = false,
  placeholder = 'Select the User Type',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOptionChange = (optionValue: string) => {
    const updatedValues = value.includes(optionValue)
      ? value.filter((v) => v !== optionValue)
      : [...value, optionValue];
    onChange(updatedValues);
  };

  const selectedLabels = options
    .filter((opt) => value.includes(opt.value))
    .map((opt) => opt.label)
    .join(', ');

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="relative w-full" ref={containerRef}>
      <div
        className={`overflow-y-auto w-full absolute border rounded px-3 cursor-pointer bg-white flex justify-between items-center ${
          isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
        onClick={() => !isDisabled && setIsOpen((prev) => !prev)}
      >
        <span className="text-sm text-gray-700">
          {selectedLabels || placeholder}
        </span>
                <img src={downArrow} alt="arrow-right" className="w-4 h-8" />
      </div>

      {isOpen && !isDisabled && (
        <div className="absolute z-10 w-full mt-10 border rounded bg-white shadow-md max-h-60 overflow-y-auto">
          <div className="p-2 border-b">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search..."
              className="w-full p-1 border rounded text-sm"
            />
          </div>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <label key={option.value} className="flex items-center px-3 py-2 hover:bg-gray-100">
                <input
                  type="checkbox"
                  checked={value.includes(option.value)}
                  onChange={() => handleOptionChange(option.value)}
                  className="mr-2"
                />
                <span className="text-sm text-gray-800">{option.label}</span>
              </label>
            ))
          ) : (
            <div className="px-3 py-2 text-sm text-gray-500">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
